import Geocode from 'react-geocode';
import cmsApi from '../api/cmsApi';
import { actions as notificationActions } from './notificationActions';
import * as logger from '../utils/logger';
import config from '../config';

Geocode.setApiKey(config.GOOGLE_MAPS_API_KEY);
Geocode.setLanguage('pl');

export const types = {
  LOAD_CMS_DATA: 'LOAD_CMS_DATA',
  LOAD_CMS_DATA_SUCCESS: 'LOAD_CMS_DATA_SUCCESS',
  UPDATE_CMS_DATA_LOCATION: 'UPDATE_CMS_DATA_LOCATION',
};

export const actions = {
  loadDetails: () => dispatch => {
    dispatch({ type: types.LOAD_CMS_DATA });

    return cmsApi
      .getContent()
      .then(result => {
        if (result.ok) {
          const cms = result.data;
          return dispatch({ type: types.LOAD_CMS_DATA_SUCCESS, cms });
        }

        dispatch(notificationActions.showError('Nie udało się pobrać ustawień klienta'));
        return logger.error(result);
      });
  },

  retrieveUnitLocation: () => (dispatch, getState) => {
    const cms = getState().cms;
    Geocode.fromAddress(cms.address).then(
      response => {
        if (response.status === "OK") {
          const { lat, lng } = response.results[0].geometry.location;
          return dispatch({ type: types.UPDATE_CMS_DATA_LOCATION, location: { ok: true, lat, lng } });
        } else {
          return dispatch({ type: types.UPDATE_CMS_DATA_LOCATION, location: { ok: false } });
        }
      },
      error => {
        console.error(error);
        return dispatch({ type: types.UPDATE_CMS_DATA_LOCATION, location: { ok: false } });
      }
    );
  },
};



// WEBPACK FOOTER //
// ./src/actions/cmsActions.js